import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BookingService } from '../../booking/booking-services/booking.service';
import { BookingRecapRequest, BookRecapResponse } from '../../booking/booking-services/model/booking';
import { SendTicketObject } from '../../booking/booking-services/model/ticket';
import { UserAccountService } from '../../user-account/user-account.service';

@Component({
    selector: 'app-general-booking-detail',
    templateUrl: 'general-booking-detail.html',
    styleUrls:['./general-booking-detail.css']
})

export class GeneralBookingComponent implements OnInit {
    bookingDetails:BookRecapResponse={Amount:'0',BookingStatus:'Nil',FirstName:'Nil',LastName:'Nil',TotalSalesAmount:'0',Pnr:'Nil',Customer:null,BookingDate:null};
    bookRQ:BookingRecapRequest={'LastName':'',Pnr:''};
    isTicketSend:boolean=false;
    isInvoiceSend:boolean=false;
    constructor(private _userAccountService:UserAccountService,private route: ActivatedRoute,private _router: Router,private booking:BookingService) { }

    ngOnInit() {
        this.getPaymentGateWayParams();
     }

    getBookingDetail(){
        this.booking.getBookingDetail(this.bookRQ).subscribe((res:any)=>{
          //  console.log(res)
            if(res.message == 'success' && res.status){
                this.bookingDetails = res.data;
            }
        })
    }

    sendTicket(type:number){
        var reqDept : SendTicketObject = {
          pnr : this.bookingDetails.Pnr,
          subject:'Travel Ticket',
          type:type,
          toEmail:this.bookingDetails.Customer.Email
        }
        this._userAccountService.sendTicket(reqDept).subscribe((res:any)=>{
          if(res.status == true && res.message == 'success'){
            if(type == 1){
              this.isInvoiceSend = true;
            }else{
              this.isTicketSend = true;
            }
           // alert("Message Send")
          }
        });
    }

    getPaymentGateWayParams(){
        this.bookRQ.Pnr = this.route.snapshot.paramMap.get('id');
        this.bookRQ.LastName = this.route.snapshot.queryParamMap.get('lastname');

        this.getBookingDetail();
    }
}